import { Service } from "typedi";
import { Repository } from "./repository";
import { Token } from "portail-api-client";

@Service()
export class TokenRepository extends Repository<Token> {
  clazz = undefined
  key = "auth_token"
}
